import React from "react";
import { withRouter } from "react-router-dom";
import PopupComponent from "../Components/popupComponent";


const UnauthStartPage = ({ routerProps, startUI }) => {
    return (
        <div>
            {startUI}
            <PopupComponent/>
        </div>
    );
};

export default withRouter(UnauthStartPage);